(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function build(slides) {
      slides.querySelectorAll('[data-marquee-clone]').forEach(function (n) {
        n.remove();
      });
      slides.classList.remove('is-ready');

      var slider = slides.closest('.announcement-bar__slider--marquee');
      if (!slider) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var originals = Array.prototype.slice.call(slides.children);
      if (!originals.length) return;

      function addSet() {
        return originals.map(function (el) {
          var c = el.cloneNode(true);
          c.setAttribute('data-marquee-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.setAttribute('inert', '');
          c.querySelectorAll('[id]').forEach(function (n) {
            n.removeAttribute('id');
          });
          c.querySelectorAll('a, button').forEach(function (n) {
            n.setAttribute('tabindex', '-1');
          });
          slides.appendChild(c);
          return c;
        });
      }

      var firstClones = addSet();
      var distance =
        firstClones[0].getBoundingClientRect().left -
        originals[0].getBoundingClientRect().left;
      if (distance <= 0) return;

      var setsNeeded = Math.ceil(slider.clientWidth / distance) + 1;
      for (var sets = 2; sets < setsNeeded; sets++) {
        addSet();
      }

      var speed = Number(slider.getAttribute('data-speed')) || 5;
      slides.style.setProperty('--marquee-distance', distance + 'px');
      slides.style.setProperty('--marquee-duration', distance / (speed * 10) + 's');
      slides.classList.add('is-ready');
    }

    function init(root) {
      (root || document)
        .querySelectorAll('.announcement-bar__slider--marquee .announcement-bar__slides')
        .forEach(build);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        init(document);
      }, 200);
    });

    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        init(document);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
